import { IconModule } from "./../icon/icon.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AlertComponent } from "./alert.component";

@NgModule({
	declarations: [AlertComponent],
	imports: [CommonModule, IconModule],
	exports: [AlertComponent]
})
export class AlertModule {}
